<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-bottom="6"
        offset-y
        left
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon small v-bind="attrs" v-on="on" title="Colunas">
                <v-icon>mdi-cog-outline</v-icon>
            </v-btn>
        </template>

        <v-card width="340">
            <v-card-title class="py-3">
                <div>
                    <div class="text-subtitle-1">Colunas</div>
                    <div class="text-caption grey--text">
                        {{ local.length }} de {{ colunas.length }} visíveis
                    </div>
                </div>
                <v-spacer/>
                <v-btn text x-small @click="restaurar">Restaurar padrão</v-btn>
            </v-card-title>

            <v-divider/>

            <div :style="`max-height: ${altura}px; overflow-y: auto;`">
                <!-- Ordem da lista = ordem das colunas no grid. As visíveis primeiro, arrastáveis. -->
                <draggable v-model="ordenadas" handle=".arrastar" @end="emitir">
                    <div
                        v-for="item in ordenadas"
                        :key="item.value"
                        class="d-flex align-center px-2 linha-coluna"
                    >
                        <v-icon small class="arrastar mr-1">mdi-drag-horizontal-variant</v-icon>
                        <v-checkbox
                            :input-value="true"
                            :disabled="item.fixa"
                            :label="item.text"
                            dense
                            hide-details
                            class="mt-0 pt-0"
                            @change="desmarcar(item)"
                        />
                    </div>
                </draggable>

                <template v-if="ocultas.length">
                    <v-divider class="my-1"/>
                    <div class="text-overline grey--text px-3">Ocultas</div>

                    <div
                        v-for="item in ocultas"
                        :key="item.value"
                        class="d-flex align-center px-2 linha-coluna"
                    >
                        <v-icon small class="mr-1" style="visibility: hidden;">mdi-drag-horizontal-variant</v-icon>
                        <v-checkbox
                            :input-value="false"
                            :label="item.text"
                            dense
                            hide-details
                            class="mt-0 pt-0"
                            @change="marcar(item)"
                        />
                    </div>
                </template>
            </div>
        </v-card>
    </v-menu>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'ColunasMenu',

    components: {
        draggable,
    },

    props: {
        value: {
            type: Array,
            required: true,
        },

        // Catálogo da tela, criado por `criarCatalogoColunas` (utils/catalogoColunas).
        catalogo: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            menu: false,
            local: this.catalogo.normalizarColunas(this.value),
        };
    },

    computed: {
        colunas() {
            return this.catalogo.COLUNAS;
        },

        ordenadas: {
            get() {
                return this.local.map(v => this.catalogo.coluna(v)).filter(Boolean);
            },
            set(lista) {
                this.local = lista.map(c => c.value);
            },
        },

        ocultas() {
            return this.colunas.filter(c => !this.local.includes(c.value));
        },

        altura() {
            return Math.max(280, this.$vuetify.breakpoint.height - 300);
        },
    },

    watch: {
        value: {
            deep: true,
            handler(novo) {
                this.local = this.catalogo.normalizarColunas(novo);
            },
        },
    },

    methods: {
        desmarcar(item) {
            if (item.fixa) {
                return;
            }

            this.local = this.local.filter(v => v !== item.value);
            this.emitir();
        },

        marcar(item) {
            const indiceCatalogo = this.colunas.findIndex(c => c.value === item.value);
            const destino = this.local.findIndex(
                v => this.colunas.findIndex(c => c.value === v) > indiceCatalogo
            );

            destino === -1
                ? this.local.push(item.value)
                : this.local.splice(destino, 0, item.value);

            this.emitir();
        },

        restaurar() {
            this.local = this.catalogo.colunasPadrao();
            this.emitir();
        },

        emitir() {
            this.$emit('input', this.catalogo.normalizarColunas(this.local));
        },
    },
};
</script>

<style scoped>
.linha-coluna {
    min-height: 34px;
}

.arrastar {
    cursor: grab;
}
</style>
